import {
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signOut,
} from 'firebase/auth'
import { toast } from 'react-toastify'
import { verifyLogin } from './index'
import store, { resetStores } from 'src/store'
import { getSetupData } from 'src/reducers/setupData/services/setupDataThunk'
import { unregisterScreenFunction } from 'src/clinic/components/ClinicHomePage/hooks/useAumhumScreen'

export const handleGoogleLogin = async (
  handlePostLogin,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
) => {
  const provider = new GoogleAuthProvider()
  const auth = getAuth()
  signInWithPopup(auth, provider)
    .then(async (result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      //const credential = GoogleAuthProvider.credentialFromResult(result);
      const user = result?.user
      const firebaseIdToken = await user?.getIdToken()
      handlePostSocialLogin(
        handlePostLogin,
        firebaseIdToken,
        setErrorText,
        doBasicOnboardingInside,
        setBasicOnboardingFlowVisible,
        setProfileDataForBasicOnboarding,
      )
    })
    .catch((error) => {
      const errorMessage = error.message
      console.log(errorMessage)
      handlePostSocialLogin(handlePostLogin)
    })
}

export const handleFacebookLogin = async (
  handlePostLogin,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
) => {
  const provider = new FacebookAuthProvider()
  const auth = getAuth()
  signInWithPopup(auth, provider)
    .then(async (result) => {
      // The signed-in user info.
      const user = result.user

      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      const credential = FacebookAuthProvider.credentialFromResult(result)
      const facebookAccessToken = credential.accessToken

      console.log(result)

      // Get Firebase ID token to send to our server
      const firebaseIdToken = await user?.getIdToken()

      handlePostSocialLogin(
        handlePostLogin,
        firebaseIdToken,
        setErrorText,
        doBasicOnboardingInside,
        setBasicOnboardingFlowVisible,
        setProfileDataForBasicOnboarding,
      )

      // IdP data available using getAdditionalUserInfo(result)
      // ...
    })
    .catch((error) => {
      // Handle Errors Here.
      const errorMessage = error.message
      console.log(errorMessage)
      handlePostSocialLogin(handlePostLogin)
    })
}

export const handleAppleLogin = async (
  handlePostLogin,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
) => {
  const provider = new OAuthProvider('apple.com')
  const auth = getAuth()
  signInWithPopup(auth, provider)
    .then(async (result) => {
      // The signed-in user info.
      const user = result?.user
      // Apple credential
      // const credential = OAuthProvider.credentialFromResult(result);
      const firebaseIdToken = await user?.getIdToken()
      handlePostSocialLogin(
        handlePostLogin,
        firebaseIdToken,
        setErrorText,
        doBasicOnboardingInside,
        setBasicOnboardingFlowVisible,
        setProfileDataForBasicOnboarding,
      )
    })
    .catch((error) => {
      // Handle Errors Here.
      const errorMessage = error.message
      console.log(errorMessage)
      handlePostSocialLogin(handlePostLogin)
    })
}

export const handlePostSocialLogin = async (
  handlePostLogin,
  accessToken,
  setErrorText,
  doBasicOnboardingInside,
  setBasicOnboardingFlowVisible,
  setProfileDataForBasicOnboarding,
) => {
  if (!accessToken) {
    console.log('Error Signing In')
    toast.error('Invalid Social Login Attempt!')
    return
  }
  const response = await verifyLogin(accessToken)
  handlePostLogin(
    response,
    setErrorText,
    doBasicOnboardingInside,
    setBasicOnboardingFlowVisible,
    setProfileDataForBasicOnboarding,
  )
}

export const logoutHandler = (
  removeLocalStorageExceptKeys = [],
  removeSessionStorageExceptKeys = [],
) => {
  // todo later, not now: remove all,  except important
  let lanCode = sessionStorage.getItem('languageCode')
  let autoNavigatedToEmrOnceInSession
  if (
    removeSessionStorageExceptKeys.includes('autoNavigatedToEmrOnceInSession') &&
    sessionStorage.getItem('autoNavigatedToEmrOnceInSession')
  ) {
    autoNavigatedToEmrOnceInSession = sessionStorage.getItem('autoNavigatedToEmrOnceInSession')
  }

  const removeLocalStorageKeys = [
    'token',
    'accessTokenExpiry',
    'accessTokenExpiryReadable',
    'authorities',
    'FCMToken',
    'submittedFCMTokenForThisUser',
    'ROLE_CA_CONFIG',
    'ROLE_SCREEN_CONFIG',
    'lastChosenFlow',
  ]
  if (removeLocalStorageExceptKeys.includes('ROLE_CA_CONFIG')) {
    unregisterScreenFunction()
  }
  
  // Preserve lastChosenFlow for dual-role users (kiosk or clinic-assistant)
  // This allows users with both ROLE_CLINIC_ASSISTANT and ROLE_AUMHUM_SCREEN
  // to be redirected to their last used portal instead of always defaulting to kiosk
  const lastChosenFlow = localStorage.getItem('lastChosenFlow')
  if (lastChosenFlow === 'kiosk' || lastChosenFlow === 'clinic-assistant') {
    if (!removeLocalStorageExceptKeys.includes('lastChosenFlow')) {
      removeLocalStorageExceptKeys.push('lastChosenFlow')
    }
  }
  removeLocalStorageKeys.forEach((key) => {
    if (!removeLocalStorageExceptKeys.includes(key)) {
      localStorage.removeItem(key)
    }
  })
  // localStorage.removeItem('onboardingType')

  console.log(autoNavigatedToEmrOnceInSession)

  sessionStorage.clear()
  sessionStorage.setItem(
    'languageCode',
    lanCode ? lanCode : navigator?.language || navigator?.userLanguage.split('-')[0],
  )
  if (autoNavigatedToEmrOnceInSession) {
    sessionStorage.setItem('autoNavigatedToEmrOnceInSession', autoNavigatedToEmrOnceInSession)
  }
  // Sign out from Firebase if user is authenticated
  const auth = getAuth()
  if (auth.currentUser) {
    signOut(auth).catch((error) => {
      // Silently handle any errors during Firebase sign out
      console.warn('Error signing out from Firebase:', error)
    })
  }
  
  setTimeout(() => {
    store.dispatch(resetStores()) // ✅ Dispatch AFTER the reducer finishes
  }, 0)
  // store.dispatch(resetStores())
  // store.dispatch(getSetupData())
  window.dispatchEvent(new Event('storage')) // goes to listeners in this tab only
}
